import React from 'react';
import PropTypes from 'prop-types';

import { loadingStyles } from './styles';

const Loading = props => {
  const { message } = props;

  const classes = loadingStyles();

  return (
    <div className={classes.container}>
      <div className={classes.spinner} />
      {message && (
        <div className={classes.message}>
          <p>Aguarde...</p>
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
};

Loading.defaultProps = {
  message: '',
};

export default Loading;
